import Box from '@mui/joy/Box';
import Drawer from '@mui/joy/Drawer';
import ModalClose from '@mui/joy/ModalClose';
import { CopyToClipboard } from "react-copy-to-clipboard";
import { RiFileCopyFill } from "react-icons/ri";
import { useEffect, useState } from "react";
import { toast } from 'react-toastify';

import CustomerOrderTable from '../components/tables/CustomerOrderTable'
import { Customers } from '../services/customersSlice';
import Loader from '../components/Loader';

const CustomerDrawer = ({ isOpen, onClose, id}) => {
  const [textToCopy, setTextToCopy] = useState(false);
  const [orderDetails, setOrderDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const phoneNumber = orderDetails?.phoneNumber

  const onCopyText = () => {
    setTextToCopy(true);
    toast.success("Copied!")
    setTimeout(() => setTextToCopy(false), 2000); 
  };

  useEffect(() => {
    const fetchOrderDetails = async () => {
        setLoading(true)
        try {
        const response = await Customers(id);
        setOrderDetails(response?.data);
        } catch (error) {
        console.error("Error fetching order details:", error);
        toast.error("Failed to load order details.");
        } finally {
        setLoading(false);
        }
    }
    fetchOrderDetails();
}, [id]);
 
  return (
    <Drawer anchor="right" open={isOpen} onClose={onClose} size="md"
      slotProps={{
        root: {
          className: `
            backdrop-blur-[1px] 
            bg-orange/20 
            rounded-tl-2xl 
          `,
        },
      }}  
    >
      <ModalClose />
      <div className="p-5">
        <h1 className="capitalize text-[24px] font-bold text-primaryRed pt-5">Customer Profile</h1>
        <h2 className="mt-2 mb-5 text-foreground text-sm text-[#0A0A0ACC]">
          Explore customer’s journey—orders, favorites, and preferences to keep them coming back.
        </h2>
        {loading ? (
          <Loader />
        ) : (
         orderDetails && (
          <div className="mt-1 space-y-4">
            <div className="grid place-items-center">
              {orderDetails.photo && (
                <img src={orderDetails.photo} alt="" className="rounded-full h-[100px] h-[100px]" />
              )}
            </div>
            <p className="text-sm text-[#0A0A0A] font-semibold">Profile Summary</p>
            <div className="mt-4 rounded-lg border px-3">
              <div className="flex justify-between items-center mt-3">
                <p className="text-xs text-[#0A0A0A] opacity-80 capialize">Name</p>
                <p className="text-xs font-medium capitalize">{orderDetails.firstName}<span className='ml-1'>{orderDetails.lastName}</span></p>
              </div>
              <div className="h-[1px] w-full border-0 bg-primaryGray my-1" />
              <div className="flex justify-between items-center mt-3">
                <p className="text-xs text-[#0A0A0A] opacity-80 capitalize">contact number</p>
                <div className='flex items-center my-1'>
                  <p className="text-xs font-medium">{phoneNumber}</p>
                  <CopyToClipboard text={phoneNumber} onCopy={onCopyText}>
                    <RiFileCopyFill class="text-gray-400 ml-1 cursor-pointer" />
                  </CopyToClipboard>
                </div>
              </div>
              <div className="h-[1px] w-full border-0 bg-primaryGray my-1" />
              <div className="flex justify-between items-center mt-3">
                <p className="text-xs text-[#0A0A0A] opacity-80 capialize">Gender</p>
                <p className="text-xs font-medium capialize">{orderDetails.gender}</p>
              </div>
              <div className="h-[1px] w-full border-0 bg-primaryGray my-1" />
              <div className='flex items-center mt-3 justify-between'>
                <p className="text-xs text-[#0A0A0A] opacity-80">Email</p>
                <p className="text-xs font-medium">{orderDetails.email}</p>
              </div>
              <div className="h-[1px] w-full border-0 bg-primaryGray my-1" />
              <div className='flex items-center mt-3 justify-between'>
                <p className="text-xs text-[#0A0A0A] opacity-80 capitalize">favorite categories</p>
                <p className="text-xs font-medium capitalize">{orderDetails.favoriteCategories} </p>
              </div>
              <div className="h-[1px] w-full border-0 bg-primaryGray my-1" />
            </div>
          </div>
        ))}
        <p className="text-sm text-[#0A0A0A] font-semibold mt-4 mb-2">Order History</p>
        <Box
            sx={{
              paddingBottom: 2,
              height: "auto",
              display: "flex",
              overflowX: "auto",
              gap: 2,
            }}
          >
            <CustomerOrderTable
              customersOrder={orderDetails}
            />
        </Box>
      </div>
    </Drawer>
  );
}

export default CustomerDrawer;